import type { TaiKhoanFB, TrangThaiExtension } from './kieu';

/** Chỉ nhận lựa chọn còn online; không lấy tài khoản đầu danh sách thay actor. */
export function chonTaiKhoan(ext: TrangThaiExtension | null, uidDaChon: string | null) {
  if (!ext?.connected || !ext.facebookLoggedIn) return null;
  const ds = ext.accounts || [];
  return ds.find(t => t.uid === uidDaChon) || ds.find(t => t.uid === ext.uid) || null;
}

export function khoaLuaChon(tenantId: string) {
  return `fbmax:${tenantId}:actor`;
}

export function choPhepAnDanh(isPage: boolean, yeuCau: boolean) {
  return !isPage && yeuCau;
}

export function tenActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return 'Chưa nhận diện tài khoản Facebook';
  if (taiKhoan.name) return taiKhoan.name;
  return taiKhoan.isPage ? `${taiKhoan.uid} · Chưa lấy được tên Page` : `${taiKhoan.uid} · Chưa lấy được tên`;
}

export function moTaActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return 'Chưa kết nối actor Facebook';
  const loai = taiKhoan.isPage ? 'Page' : 'Cá nhân';
  return `${loai} · UID ${taiKhoan.uid}`;
}

export function avatarActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return null;
  return taiKhoan.avatar || null;
}

export function tenVietTatActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return 'FB';
  if (taiKhoan.isPage && !taiKhoan.name) return 'P';
  return (taiKhoan.name || taiKhoan.uid || 'FB').slice(0, 2).toUpperCase();
}
